export default "__VITE_ASSET__197ba91a__"